import styles from './AuthLoadingScreen.module.css'

type AuthLoadingScreenProps = {
  /** Screen-reader-only live-region label announcing the auth phase. */
  label?: string
}

/**
 * The single auth-transition loader: a calm, wordless, centered breathing cyan
 * ring shown while the app resolves who the user is — the OAuth callback
 * exchange (`CallbackPage`) and `RequireAuth`'s session check both use this so
 * the whole post-login beat reads as ONE continuous loader, never a card
 * skeleton floating between the ring and the destination page.
 * See docs/ux/2026-07-02-auth-transition-microstates.md §7.
 */
export function AuthLoadingScreen({ label = 'Loading…' }: AuthLoadingScreenProps) {
  return (
    <div className={styles.screen} aria-busy="true">
      <div className={styles.mark} aria-hidden="true" />
      <span className="sr-only" role="status" aria-live="polite">
        {label}
      </span>
    </div>
  )
}
